export const HR_TASK_LIST_PAGE_SIZE = 50;
export const HR_TASK_LIST_FILTERS_STORAGE_KEY = "hrTaskListFilters";
